export const URLS = {
    REGISTRATION_URL: '/registration',
    LOGIN_URL: '/login',
    CHECK: '/check',

    MAIN_URL: '/',
    ADMIN_URL: '/admin',
    ADMIN_USERS_URL: '/admin/users',
    ADMIN_PAYEES_URL: '/admin/payees',
    ADMIN_PDF_CONTENT_URL: '/admin/pdf-content',
    PROFILE_URL: '/profile',
    COMPANIES_URL: '/companies',
    COMPANY_GROUPS_URL: '/companies/groups',
    COMPANY_URL: '/company/:id',
    SUPPLIERS_URL: '/suppliers',
    SUPPLIER_URL: '/supplier/:id',
}

export const API_ENDPOINTS = {
    USER: 'api/v1/user',
    PERMISSIONS: 'api/v1/user/permissions',
    CURRENT_USER: 'api/v1/user/current-user',
    COMPANY: 'api/v1/company',
    REPRESENTATIVE: 'api/v1/company/representative',
    ACT_HISTORY: 'api/v1/action-history',
    COMP_HISTORY: 'api/v1/company-history',
    TASK: 'api/v1/task',
    CALCULATION: 'api/v1/calculation',
    PDF: 'api/v1/pdf',
    PAYEE: 'api/v1/payee',
    CALC_TABLE: 'api/v1/calc-table',
    TTN: 'api/v1/ttn',
    DELIVERY_NOTE: 'api/v1/delivery-note',
    SUPPLIER: 'api/v1/supplier',
    SUPPLIER_REPR: 'api/v1/supplier/representative',
    SUPPLIER_HISTORY: 'api/v1/supplier-history',
    GROUP: 'api/v1/group',
}

